import React from 'react';
import MapWrapper from '../../components/Map/MapWrapper';
import PartnerListDrawer from '../../components/PartnerListDrawer';
import SearchArea from '../../components/SearchArea';
import MainLayout from '../../layout/MainLayout';
import MobileFiltersDrawer from '../../components/SearchArea/MobileFiltersDrawer';
import { useStyles } from './styles';
import PartnerProfileDrawer from '../../components/PartnerProfileModal';
import { useSelector } from 'react-redux';
import { filtersSelector } from '../../store/modules/filters/selectors';
import { useGetPartnersQuery } from '../../store/modules/services/searchPartnersApi/searchPartnersApi';
import { Typography } from '@material-ui/core';
import PartnerListMobile from '../../components/PartnerListMobile';
import { apiUrlsSelector } from '../../store/modules/fhw/selectors';
import { mapSettingsSelector } from '../../store/modules/map/selectors';

const PartnersLocator = (): JSX.Element => {
	const classes = useStyles();
	const filters = useSelector(filtersSelector);
	const apiUrls = useSelector(apiUrlsSelector);
	const mapSettings = useSelector(mapSettingsSelector);

	const { isLoading, isError } = useGetPartnersQuery({ filters, endpoint: apiUrls?.getResults, mapSettings });

	if (isLoading) return <Typography>Loading...</Typography>;
	if (isError) return <Typography>{'Error fetching data!'}</Typography>;

	return (
		<MainLayout>
			<MainLayout.SearchArea>
				<SearchArea />
			</MainLayout.SearchArea>
			<MainLayout.Content id="partner-locator-content-wrapper" className={classes?.locatorwrapper}>
				<PartnerProfileDrawer />
				<PartnerListDrawer classes={classes} />
				<MapWrapper classes={classes} />
				<PartnerListMobile />
				<MobileFiltersDrawer />
			</MainLayout.Content>
		</MainLayout>
	);
};

export default PartnersLocator;
